import React, { useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const tsmclogo =  require("../assets/images/TSMC_LOGO.jpg");
//const ChairmanSign =  require("../assets/images/chairman_signature.jpeg");
//const registartSign =  require("../assets/images/registrar_signature.jpeg");
const CPDChairmanSign =  require("../assets/images/cpdchairman_signature.jpeg");

//import chairman_Sign from "../assets/images/chairman_signature.png";
//import registrar_Sign from "../assets/images/registrar_signature.png";
const ChairmanSign =  require("../assets/images/chairman_signature.png");
const registartSign =  require("../assets/images/registrar_signature.png");


interface componentProps {
      orgRegNumber: string; 
      orgDate:string; 
      orgName:string; 
      orgExpDate:string; 

    }

const OrgPrintCertificateComponent: React.FC<componentProps> = (props:any) => {
   
  const certificateRef = useRef<HTMLDivElement>(null);
  
  const handleDownloadPDF = async () => {
  const element = certificateRef.current;
  if (!element) return;

  // 1. Capture the element with high scale for clarity
  const canvas = await html2canvas(element, {
    scale: 2, // Keeps text sharp
    useCORS: true, // Prevents image loading issues
    logging: false,
    // Forces capture of the full element height/width
    width: element.offsetWidth,
    height: element.offsetHeight,
    windowWidth: element.scrollWidth,
    windowHeight: element.scrollHeight,
    x: 0,
    y: 0
  });

  const imgData = canvas.toDataURL("image/png");

  // 2. Define custom PDF size matching your exact div (800x700 px)
  // Conversion: 1px is approx 0.75pt. 
  // Custom format: [width, height] in the specified unit.
  const pdf = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: [800, 700] 
  });

  // 3. Add image to fill the custom page
  pdf.addImage(imgData, "PNG", 0, 0, 800, 700);
  pdf.save("TGMCCertificate.pdf");
};
  return (
    <div className="container py-4">
      <div className="text-center mb-3">
        <button onClick={handleDownloadPDF} className="cme-button fw-semibold">
          <i className="bi bi-download me-2"></i>Download PDF
        </button>
      </div>

      <div
        ref={certificateRef}
        style={{
          width: "800px",
          height: "700px",
          margin: "0 auto",
          padding: "100px 60px",
          textAlign: "center",
          fontFamily: "serif",
          position: "relative",

          /* NEW — border frame */
          border: "4px double #0e7b78",
          borderRadius: "12px",
          outline: "3px solid #ffffff",         // white separation line
          outlineOffset: "-18px",               // pulls outline inward
          boxShadow: "0 0 0 6px #0b6b6a inset", // inner border for depth

          /* Optional soft paper background */
          background: "linear-gradient(#ffffff, #fdfdfd)",
          backgroundRepeat: "no-repeat",
          display: "flex",            // NEW
          flexDirection: "column",    // NEW
        }}
      >
        <img
          src={tsmclogo}
          alt="Watermark"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "260px",
            opacity: 0.05,
          }}
        />
      <div className="d-flex justify-content-between mb-4" style={{ fontSize: "16px" }}>
        <p className="fw-bold" style={{ marginLeft: "20px" }}>
          Reg.No.: {props.orgRegNumber}
        </p>
        <p className="fw-bold" style={{ marginRight: "20px" }}>
          Dt: {props.orgDate}
        </p>
      </div>


        <h2 className="text-center fw-bold mb-0">
          Telangana Medical Council
        </h2>

        <div className="text-center my-3">
              <img src={tsmclogo} alt="Logo" height={40} className="me-2" />
        </div>

        <h5 className="text-center fst-italic">
          Accreditation Certificate for CPD
        </h5>

        <div className="mt-4 fs-5" style={{ lineHeight: "1.6", fontSize: "18px" }}>
          <p>
            This is to certify that{" "}
            <span className="fw-bold text-decoration-underline">
              {props.orgName}
            </span>{" "}
            is awarded accreditation from{" "}
            <span className="fw-bold">TGMC</span> to conduct Continuous
            Professional Development Programmes with effect
            <p>
             from{" "}
            <span className="fw-bold text-decoration-underline">{props.orgDate}</span>{" "}
            valid till{" "}
            <span className="fw-bold text-decoration-underline">{props.orgExpDate}</span>.
            </p>
          </p>
        </div>

        <div className="row text-center mt-auto">   {/* mt-auto pushes it to the bottom */}
          <div className="col">
            <p>
               <img src={ChairmanSign} alt="Logo" height={40} className="me-2" />
            </p>
            <p className="fw-bold mb-0">Dr. K Mahesh Kumar</p>
            <p className="mb-0"> Chairman,TGMC</p>
          </div>
          <div className="col">
            <p>
              <img src={registartSign} alt="Logo" height={40} className="me-2" />
            </p>
            <p className="fw-bold mb-0">Dr. Dhandem Lalaiah Kumar</p>
            <p className="mb-0">Registrar,TGMC</p>
          </div>
          <div className="col">
            <p>
              <img src={CPDChairmanSign} alt="Logo" height={40} className="me-2" />
            </p>
            <p className="fw-bold mb-0">Dr. Bandari Rajkumar</p>
            <p className="mb-0">CPD Chairman,TGMC</p>
          </div>
        </div>

      </div>
    </div>
  
  );
};

export default OrgPrintCertificateComponent;